export default __webpack_public_path__ + "static/media/location.21296acc.png";